import { menuSectionFor } from '../../../../services/nav/menu-sections';
import { PageValidationType } from '../../../../models/projects/validation.models';
import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { LockedDayService } from '../../../../services/locked-day/locked-day.service';
import { OperationType } from '../../../../models/projects/operation.models';
import { NavHelperService } from '../../../../services/nav/nav-helper.service';
import { DailyObservationEditPage } from '../../../DPR Pages/daily-observations/daily-observations/daily-observation-edit';
import { DprAttachmentsEditPage } from '../../../DPR Pages/dpr-attachments/dpr-attachments-edit/dpr-attachments-edit';
import { SidebarPermissions } from '../../../../models/permissions/permission.models';
import { PermissionsService } from '../../../../services/permissions/permissions.service';
import { AppConfig } from '../../../../app/app.config';
import { JackingRobFuelFiguresPage } from '../../../DPR Pages/jacking-rob-fuel-figures/jacking-rob-fuel-figures/jacking-rob-fuel-figures';
import { VesselService } from '../../../../services/vessel/vessel.service';
import { SupportContextKey } from '../../../../models/support/support.models';

@IonicPage()
@Component({
  selector: 'page-dpr-sections-readings-submenu',
  templateUrl: 'nav-dpr-sections-submenu.html',
})
export class NavDprSectionsSubmenuPage {
  @ViewChild('content') nav: NavController;

  config = AppConfig.settings;

  sidebarCollapsed: boolean;
  permissions: SidebarPermissions = new SidebarPermissions();
  isNonJackingVessel: boolean = false;

  dprSectionPages = [];

  constructor(
    private permissionService: PermissionsService,
    public navCtrl: NavController,
    public navParams: NavParams,
    public navHelperService: NavHelperService,
    public lockedDayService: LockedDayService,
    private vesselService: VesselService,
  ) {
    this.navHelperService.currentSidebarCollapsed.subscribe(sidebarCollapsed => {
      this.sidebarCollapsed = sidebarCollapsed;
    });

  }

  ionViewDidLoad() {
  }

  async ionViewDidEnter() {
    const cachedPermissions = this.permissionService.getCachedSidebarPermissions();

    if (cachedPermissions) {
      this.permissions = cachedPermissions;
      this.isNonJackingVessel = await this.vesselService.isCurrentVesselNonJacking();
      this.dprSectionPages = this.buildDprSectionPages();
      return;
    }

    Promise.all([
      this.vesselService.isCurrentVesselNonJacking(),
      this.permissionService.sidebarPermissions()
    ]).then(res => {
      this.isNonJackingVessel = res[0];
      this.permissions = res[1];
      this.dprSectionPages = this.buildDprSectionPages();
    });
  }

  private buildDprSectionPages() {
    const pages = [
      this.sectionPage(PageValidationType.Safety),
      this.sectionPage(PageValidationType.VesselCrew),
      this.sectionPage(PageValidationType.Consumables),
      {
        title: 'Jacking Fuel ROB',
        component: JackingRobFuelFiguresPage,
        supportContextKey: SupportContextKey.DprSections,
        active: this.permissions.canClickConsumables
      },
      {
        title: 'Daily Observations',
        component: DailyObservationEditPage,
        supportContextKey: SupportContextKey.DprSections,
        active: this.permissions.canClickDailyObservations
      },
      {
        title: 'DPR Attachments',
        component: DprAttachmentsEditPage,
        supportContextKey: SupportContextKey.DprSections,
        active: this.permissions.canClickAttachments
      },
    ];

    if (!this.isNonJackingVessel) {
      return pages;
    }

    return pages.filter(page =>
      page.title !== 'Consumables' &&
      page.title !== 'Jacking Fuel ROB'
    );
  }

  private sectionPage(pageType: PageValidationType) {
    const section = menuSectionFor(pageType);
    return { ...section, active: this.permissions[section.permission] };
  }

  selectPage(page: any, type?: OperationType, title?: string, supportContextKey?: SupportContextKey) {

    this.navHelperService.navigateFromMenu({ page: page, params: {type: type},
      supportContextKey: supportContextKey, supportContextLabel: title });
  }

  collapseSidebar() {
    this.navHelperService.toggleSidebarCollapse();
  }
}



// WEBPACK FOOTER //
// ./src/pages/nav/nav-menus/nav-dpr-sections-submenu/nav-dpr-sections-submenu.ts